import React from 'react';
import { connect } from 'react-redux';
import { Navigation } from 'next/components/Navigation';
import { NEW_NAV } from 'next/entities/features';
import { NextStoreProvider } from 'next/components/Hacks';
import { selectAccountFeature } from 'reducers/account/features';
import OldNavBar from './OldNavBar';

/**
 * TODO: Delete once fully migrated to the new navigation
 */

const Navbar = ({ hasNewNav }) =>
  hasNewNav ? (
    <NextStoreProvider>
      <Navigation />
    </NextStoreProvider>
  ) : (
    <OldNavBar />
  );

const mapStateToProps = state => ({
  hasNewNav: selectAccountFeature(state, NEW_NAV),
});

export default connect(mapStateToProps)(Navbar);
